export const PANEL_TYPES = {
    SUMMARY: 'summary',
    CHANNELS: 'channels',
    ANNOTATIONS: 'annotations',
    EVENTS: 'events',
    POSITIONS: 'positions',
    SPO2: 'spo2',
    HR: 'hr',
};
